import { render, staticRenderFns } from "./wdmr_data_show.vue?vue&type=template&id=8d60bc02&"
import script from "./wdmr_data_show.vue?vue&type=script&lang=js&"
export * from "./wdmr_data_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports